import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Profile from './pages/profile/Profile';
import RecruitManage from './pages/RecruitManage';
import ScrapManage from './pages/scrap/ScrapManage';
import PostingEdit from './pages/posting/PostingEdit';
import ResumeEdit from './pages/resume/ResumeEdit';
import ResumeView from './pages/resume/ResumeView';
import ServiceManage from './pages/service/ServiceManage';
import RetreatPostingManage from './pages/retreat/RetreatPostingManage';
import RetreatPostingEdit from './pages/retreat/RetreatPostingEdit';
import AiSermonManage from './pages/aisermon/AiSermonManage';
import ApplicantManage from './pages/posting/ApplicantManage';
import ApplicantResume from './pages/posting/ApplicantResume';
import ApplicationDetail from './pages/resume/ApplicationDetail';
import TalentSearch from './pages/posting/TalentSearch';
import ProfilePageEdit from './pages/profilepage/ProfilePageEdit';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

// 공고 알림은 이력서 관리 안으로 합쳐짐 — 옛 링크의 ?draft= 는 그대로 넘긴다
function AlertsRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/mypage/resumemanage${search}`} replace />;
}

export default function MypageRouter() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<Profile/>}/>
        <Route path="/scrapmanage" element={<ScrapManage/>}/>
        <Route path="/postingmanage" element={<RecruitManage section="posting"/>}/>
        <Route path="/postingedit" element={<PostingEdit/>}/>
        <Route path="/retreatpostingmanage" element={<RetreatPostingManage/>}/>
        <Route path="/retreatpostingedit" element={<RetreatPostingEdit/>}/>
        <Route path="/resumemanage" element={<RecruitManage section="resume"/>}/>
        <Route path="/applicationmanage" element={<Navigate to="/mypage/applications" replace />}/>
        {/* 지원현황 (application-status-design.md 4·5장) */}
        <Route path="/applications" element={<RecruitManage section="resume"/>}/>
        <Route path="/applications/:id" element={<ApplicationDetail/>}/>
        <Route path="/applicantmanage" element={<ApplicantManage/>}/>
        <Route path="/applicantresume" element={<ApplicantResume/>}/>
        {/* 교회 인재 검색 (application-status-design.md 7장) */}
        <Route path="/talent" element={<TalentSearch/>}/>
        {/* P1 공고 알림 — 이력서 관리 화면 하단 섹션으로 이동 */}
        <Route path="/alerts" element={<AlertsRedirect/>}/>
        <Route path="/resumeedit" element={<ResumeEdit/>}/>
        <Route path="/resumeview" element={<ResumeView/>}/>
        {/* 프로필페이지 — 전용 설정만 저장, 공통 정보는 이력서에서 (server/routers/minister/MinisterProfile.js) */}
        <Route path="/profilepage" element={<ProfilePageEdit/>}/>
        <Route path="/profilepagemanage" element={<Navigate to="/mypage/profilepage" replace />}/>
        <Route path="/profilepageedit" element={<Navigate to="/mypage/profilepage" replace />}/>
        <Route path="/aisermonmanage" element={<AiSermonManage/>}/>
        <Route path="/servicemanage" element={<ServiceManage/>}/>
        <Route path="/servicemanage/*" element={<Navigate to="/mypage/servicemanage" replace />}/>
      </Routes>
      <Footer />
    </div>
  )
}
